import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/font-awesome';
import { FormatUtils } from '@/infra/utils/format.utils';
import { useCartStore } from '@/store/cart_store';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartButton',
  emits: ["open-cart-modal"],
  setup(__props, { expose: __expose }) {
  __expose();

const cartStore = useCartStore();

const isMouseOver = ref(false);




const __returned__ = { cartStore, isMouseOver, get Icons() { return Icons }, get FormatUtils() { return FormatUtils }, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})